import {GET_ERRORS_STARTED} from "../../../reducers/errorsReducer";


export const getErrorsStarted = () =>{
    return {
        type: GET_ERRORS_STARTED,
        payload: {}
    }
}